import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
import Moment from 'moment';
import { CSVLink } from 'react-csv';
import { SortableTh, sortRows, nextSort } from '../common/sortable-th';
import { DateRangeInput } from '../common/date-range-input';

function fmtMoney(val) {
    if (val === null || val === undefined || val === '') return '—';
    return 'S/ ' + parseFloat(val).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function today() {
    return Moment().format('YYYY-MM-DD');
}

// mismo patrón de exportación que ver-report-sku-for-month / ver-report-customers-list (react-csv)
function csvFilename(base, from, to) {
    return `${base}_${from}_a_${to}.csv`;
}

const PRODUCT_HEADERS = [
    { label: 'SKU', key: 'sku' },
    { label: 'Categoría', key: 'category' },
    { label: 'Subcategoría', key: 'subcategory' },
    { label: 'Cantidad vendida', key: 'quantity' },
    { label: 'Nro de pedidos', key: 'orders' },
    { label: 'Total vendido', key: 'total' },
];

export class VerReportProductsSold extends Component {
    constructor(props) {
        super(props);
        this.applyDateRange = this.applyDateRange.bind(this);
        this.handleSort = this.handleSort.bind(this);

        this.state = {
            loading: false,
            products: [],
            categoryTotals: [],
            subcategoryTotals: [],
            rangeFrom: '',
            rangeTo: '',
            dateFrom: today(),
            dateTo: today(),
            page: 1,
            sort: { key: 'quantity', dir: 'desc' },
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        const user = AuthService.getCurrentUser();
        this.setState({ loading: true });
        ApiService.getProductsSold(user.token, this.state.dateFrom, this.state.dateTo).then(
            (res) => {
                if (res && res.status === 'success') {
                    this.setState({
                        loading: false,
                        products: res.data.products || [],
                        categoryTotals: res.data.categoryTotals || [],
                        subcategoryTotals: res.data.subcategoryTotals || [],
                        rangeFrom: res.data.from,
                        rangeTo: res.data.to,
                        page: 1,
                    });
                } else {
                    this.setState({ loading: false, products: [], categoryTotals: [], subcategoryTotals: [] });
                }
            },
            () => {
                this.setState({ loading: false, products: [], categoryTotals: [], subcategoryTotals: [] });
            }
        );
    }

    applyDateRange(from, to) {
        this.setState({ dateFrom: from, dateTo: to }, () => this.getData());
    }

    handleSort(key) {
        this.setState((prev) => ({
            sort: nextSort(prev.sort, key),
            page: 1,
        }));
    }

    renderStats() {
        const { products } = this.state;
        const totalUnits = products.reduce((sum, p) => sum + (parseFloat(p.quantity) || 0), 0);
        const totalRevenue = products.reduce((sum, p) => sum + (parseFloat(p.total) || 0), 0);
        const stats = [
            { label: 'Productos distintos', value: products.length, icon: 'fa-cubes', color: '#0d6efd' },
            { label: 'Unidades vendidas', value: totalUnits, icon: 'fa-shopping-basket', color: '#27ae60' },
            { label: 'Monto vendido', value: fmtMoney(totalRevenue), icon: 'fa-money', color: '#8e44ad' },
        ];

        return (
            <>
                <style>{`
                  .rps-stats-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 12px;
                    margin-bottom: 16px;
                  }
                  @media (max-width: 700px) {
                    .rps-stats-grid { grid-template-columns: 1fr; }
                  }
                `}</style>
                <div className="rps-stats-grid">
                    {stats.map((s) => (
                        <div
                            key={s.label}
                            style={{
                                minWidth: 0,
                                background: '#fff', border: '1px solid #ebebeb', borderRadius: 10,
                                padding: 14, display: 'flex', alignItems: 'center', gap: 12,
                            }}
                        >
                            <div style={{
                                width: 42, height: 42, borderRadius: '50%', flexShrink: 0,
                                background: s.color + '18', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}>
                                <i className={'fa ' + s.icon} style={{ color: s.color, fontSize: 17 }} />
                            </div>
                            <div style={{ minWidth: 0 }}>
                                <div style={{ fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                                    {s.label}
                                </div>
                                <div style={{ fontSize: 18, fontWeight: 700, color: '#222' }}>
                                    {s.value}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </>
        );
    }

    // tabla chica reusada para los totalizados por categoría y por subcategoría
    renderGroupTotals(title, rows, columns, csvFile) {
        if (!rows || rows.length === 0) return null;

        const csvHeaders = [
            ...columns,
            { label: 'Unidades vendidas', key: 'quantity' },
            { label: 'Monto vendido', key: 'total' },
        ];

        return (
            <div className="card" style={{ boxShadow: 'none', border: '1px solid #ebebeb' }}>
                <div className="card-header" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                    <h5>{title}</h5>
                    <CSVLink className="btn btn-outline-primary btn-sm" data={rows} headers={csvHeaders} filename={csvFile}>
                        <i className="fa fa-file-excel-o" style={{ marginRight: 6 }} />
                        Exportar
                    </CSVLink>
                </div>
                <div className="card-body" style={{ padding: 0 }}>
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                            <thead>
                                <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #ebebeb' }}>
                                    {columns.map((c) => (
                                        <th key={c.key} style={{ padding: '10px 12px', color: '#888', fontWeight: 600, textAlign: 'left', whiteSpace: 'nowrap' }}>
                                            {c.label}
                                        </th>
                                    ))}
                                    <th style={{ padding: '10px 12px', color: '#888', fontWeight: 600, textAlign: 'left', whiteSpace: 'nowrap' }}>
                                        Unidades vendidas
                                    </th>
                                    <th style={{ padding: '10px 12px', color: '#888', fontWeight: 600, textAlign: 'left', whiteSpace: 'nowrap' }}>
                                        Monto vendido
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, idx) => (
                                    <tr key={idx} style={{ borderBottom: '1px solid #f4f4f4' }}>
                                        {columns.map((c) => (
                                            <td key={c.key} style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>
                                                {row[c.key]}
                                            </td>
                                        ))}
                                        <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                                            <span style={{ background: '#d4edda', color: '#155724', borderRadius: 10, padding: '2px 9px', fontSize: 12, fontWeight: 600 }}>
                                                {row.quantity}
                                            </span>
                                        </td>
                                        <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 700 }}>
                                            {fmtMoney(row.total)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    renderPagination(total, page, pageSize, onPageChange) {
        const totalPages = Math.ceil(total / pageSize);
        if (totalPages <= 1) return null;
        const from = (page - 1) * pageSize + 1;
        const to = Math.min(page * pageSize, total);
        return (
            <div style={{
                display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between',
                padding: '10px 16px', borderTop: '1px solid #f0f0f0', gap: 8,
                background: '#fafafa', fontSize: 13, color: '#666',
            }}>
                <span style={{ fontSize: 12, color: '#aaa' }}>{from}–{to} de {total}</span>
                <div style={{ display: 'flex', gap: 6 }}>
                    <button
                        disabled={page === 1}
                        onClick={() => onPageChange(page - 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === 1 ? '#f4f4f4' : '#fff',
                            color: page === 1 ? '#ccc' : '#333',
                            cursor: page === 1 ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-left' />
                    </button>
                    <span style={{ padding: '4px 10px', fontSize: 13, color: '#555' }}>{page} / {totalPages}</span>
                    <button
                        disabled={page === totalPages}
                        onClick={() => onPageChange(page + 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === totalPages ? '#f4f4f4' : '#fff',
                            color: page === totalPages ? '#ccc' : '#333',
                            cursor: page === totalPages ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-right' />
                    </button>
                </div>
            </div>
        );
    }

    renderResults() {
        const { products, page, sort, loading } = this.state;
        if (loading) return <div style={{ padding: 16, color: '#888' }}>Cargando...</div>;
        if (products.length === 0) return <div style={{ padding: 16, color: '#888' }}>No hay productos vendidos en el rango seleccionado.</div>;

        const PAGE_SIZE = 50;
        const sorted = sortRows(products, sort);
        const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
        const currentPage = Math.min(page, totalPages);
        const paginated = sorted.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);
        const headers = PRODUCT_HEADERS;

        return (
            <div style={{ border: '1px solid #ebebeb', borderRadius: 10, overflow: 'hidden' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                        <thead>
                            <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #ebebeb' }}>
                                {headers.map((h) => (
                                    <SortableTh key={h.key} header={h} sort={sort} onSort={this.handleSort} />
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {paginated.map((item) => (
                                <tr
                                    key={item.id_product}
                                    style={{ borderBottom: '1px solid #f4f4f4' }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = '#f0faf4')}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = '')}
                                >
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 500 }}>
                                        {item.sku}
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>
                                        {item.category}
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>
                                        {item.subcategory}
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                                        <span style={{ background: '#d4edda', color: '#155724', borderRadius: 10, padding: '2px 9px', fontSize: 12, fontWeight: 600 }}>
                                            {item.quantity}
                                        </span>
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>
                                        {item.orders}
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 700 }}>
                                        {fmtMoney(item.total)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.renderPagination(sorted.length, currentPage, PAGE_SIZE, (p) => this.setState({ page: p }))}
            </div>
        );
    }

    render() {
        const { categoryTotals, subcategoryTotals, products, sort, dateFrom, dateTo } = this.state;
        const sortedProducts = sortRows(products, sort);
        return (
            <Fragment>
                <Breadcrumb title="Productos vendidos" parent="Analítica" />

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card" style={{ marginBottom: 16 }}>
                                <div className="card-body" style={{ padding: '12px 16px' }}>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
                                        <span style={{ fontSize: 13, fontWeight: 600, color: '#555', whiteSpace: 'nowrap' }}>
                                            Filtrar por fecha
                                        </span>
                                        <DateRangeInput
                                            from={this.state.dateFrom}
                                            to={this.state.dateTo}
                                            onApply={this.applyDateRange}
                                        />
                                    </div>
                                </div>
                            </div>

                            {this.renderStats()}

                            <div className="row">
                                <div className="col-md-6">
                                    {this.renderGroupTotals(
                                        'Totalizado por categoría',
                                        categoryTotals,
                                        [{ label: 'Categoría', key: 'category' }],
                                        csvFilename('totales-por-categoria', dateFrom, dateTo)
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {this.renderGroupTotals(
                                        'Totalizado por subcategoría',
                                        subcategoryTotals,
                                        [
                                            { label: 'Categoría', key: 'category' },
                                            { label: 'Subcategoría', key: 'subcategory' },
                                        ],
                                        csvFilename('totales-por-subcategoria', dateFrom, dateTo)
                                    )}
                                </div>
                            </div>

                            <div className="card" style={{ boxShadow: 'none', border: '1px solid #ebebeb' }}>
                                <div className="card-header" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                                    <h5>Listado</h5>
                                    {products.length > 0 && (
                                        <CSVLink
                                            className="btn btn-outline-primary btn-sm"
                                            data={sortedProducts}
                                            headers={PRODUCT_HEADERS}
                                            filename={csvFilename('productos-vendidos', dateFrom, dateTo)}
                                        >
                                            <i className="fa fa-file-excel-o" style={{ marginRight: 6 }} />
                                            Exportar
                                        </CSVLink>
                                    )}
                                </div>
                                <div className="card-body" style={{ padding: 0 }}>
                                    {this.renderResults()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default VerReportProductsSold;
